import React from "react";
import styled from "styled-components";
import CircularProgress from "@material-ui/core/CircularProgress";

const Button = styled.button`
  background: ${(props) => (props.alternateColor ? "none" : "linear-gradient(#00ee46, #0e9e38)")};
  border: ${(props) => (props.alternateColor ? "2px solid #07c43f" : "none")};
  border-radius: 100px;
  color: ${(props) => (props.alternateColor ? "#07c43f" : "#FFF")};
  cursor: pointer;
  font-family: DM Sans, sans-serif;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0px;
  height: 56px;
  padding: 15px 36px;
  margin-left: 35px;
  text-transform: none;
  white-space: nowrap;
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};

  @media (max-width: 900px) {
    font-size: .9rem;
    font-weight: 400;
    // height: 38px;
    height: unset;
    white-space: unset;
    padding: 8px 16px;
    margin-top: 18px;
    margin-left: 18px;
  }
`;

export const SaveButton = React.forwardRef((props, ref) => {
  return (
    <Button alternateColor={props.alternateColor} disabled={props.disabled} onClick={props.onClick} ref={ref}>
      {props.isLoading ? (
        <CircularProgress
          size={23}
          thickness={6}
          style={{
            color: "#FFF",
          }}
        />
      ) : (
        props.text ? props.text : "Save"
      )}
    </Button>
  );
});
